import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuthStore } from "../stores/auth";
import { paths } from "./paths";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: { app: string; role: string };
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { session, appRoles, isLoading } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!session) {
    return <Navigate to={paths.login} state={{ from: location }} replace />;
  }

  if (requiredRole) {
    const hasRole = appRoles.some(
      (r) => r.app === requiredRole.app && r.role === requiredRole.role,
    );
    if (!hasRole) {
      return <Navigate to={paths.dashboard} replace />;
    }
  }

  return <>{children}</>;
}
